export default __webpack_public_path__ + "static/media/banner.c2283b5f.jpg";